"use strict";

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var redux_1 = require("redux");
var react_router_redux_1 = require("react-router-redux");
var redux_saga_1 = __importDefault(require("redux-saga"));
var effects_1 = require("redux-saga/effects");
var authActions_1 = require("./actions/authActions");
var reducer_1 = __importDefault(require("./reducer"));
var sideEffect_1 = require("./sideEffect");
var i18n_1 = require("./i18n");
var formMiddleware_1 = __importDefault(require("./form/formMiddleware"));
exports.default = function (_a) {
  var dataProvider = _a.dataProvider,
    history = _a.history,
    _b = _a.customReducers,
    customReducers = _b === void 0 ? {} : _b,
    _c = _a.authProvider,
    authProvider = _c === void 0 ? null : _c,
    _d = _a.customSagas,
    customSagas = _d === void 0 ? [] : _d,
    _e = _a.i18nProvider,
    i18nProvider = _e === void 0 ? i18n_1.defaultI18nProvider : _e,
    initialState = _a.initialState,
    _f = _a.locale,
    locale = _f === void 0 ? 'en' : _f;
  var messages = i18nProvider(locale);
  var appReducer = reducer_1.default(customReducers, locale, messages);
  var resettableAppReducer = function resettableAppReducer(state, action) {
    return appReducer(action.type !== authActions_1.USER_LOGOUT ? state : undefined, action);
  };
  var saga = function rootSaga() {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, effects_1.all([sideEffect_1.adminSaga(dataProvider, authProvider, i18nProvider)].concat(customSagas).map(effects_1.fork))];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  };

  var sagaMiddleware = redux_saga_1.default();
  var typedWindow = window;
  var store = redux_1.createStore(resettableAppReducer, initialState, redux_1.compose(redux_1.applyMiddleware(sagaMiddleware, formMiddleware_1.default, react_router_redux_1.routerMiddleware(history)), typeof typedWindow !== 'undefined' && typedWindow.__REDUX_DEVTOOLS_EXTENSION__ ? typedWindow.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
    return f;
  }));
  sagaMiddleware.run(saga);
  return store;
};